import { Helmet } from 'react-helmet-async';

const SEOHead = ({
  title = 'Boop - Best of Online Prompts',
  description = 'Share, rate, and improve AI prompts with the community. Discover top-rated prompts for ChatGPT, Claude, and more.',
  image,
  url = 'https://boopboop.io',
  type = 'website',
}) => {
  const apiBase = process.env.REACT_APP_API_URL || 'https://api.boopboop.io';
  const ogImage = image || `${apiBase}/og/default.png`;
  const fullTitle = title.includes('Boop') ? title : `${title} | Boop`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Boop" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@boopboop" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional Meta */}
      <meta name="author" content="Boop" />
      <meta name="keywords" content="AI prompts, ChatGPT, Claude, prompt engineering, prompt sharing, AI agents, MCP servers" />
    </Helmet>
  );
};

export default SEOHead;
